export default "__VITE_ASSET__CF32OXA___"